import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import CardWithNumberNoBorder from "../generic/CardWithNumberNoBorder";
import { ReactComponent as GridDecoration } from "../../assets/decorations/greenBannerGrid.svg";
import PrimaryButton from "../generic/PrimaryButton";
import OutlinedButton from "../generic/OutlinedButton";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const FirebaseGetStarted = ({
  primaryButtonStyle,
  primaryButtonVariant,
  outlineButtonStyle,
  outlineButtonVariant,
}) => {
  const cards = [
    {
      number: "1",
      title: "Integrate the SDK",
      subtitle: "Drop-in replacement for Firebase with minimal setup.",
    },
    {
      number: "2",
      title: "Track Installs & Events",
      subtitle: "Start capturing key actions instantly.",
    },
    {
      number: "3",
      title: "Replace & Manage Links",
      subtitle: "Set up smart links and fallback flows.",
    },
  ];
  return (
    <FullPageContainer>
      <DecorationWrapper>
        <GridDecoration />
      </DecorationWrapper>
      <Container id={"getStartedQuicklyProduct"}>
        <Title>Ready to switch?</Title>
        <Content>
          {cards.map((item, index) => (
            <CardWithNumberNoBorder
              key={index}
              number={item.number}
              title={item.title}
              subtitle={item.subtitle}
            />
          ))}
        </Content>
        <Content2>
          <Line>
            <PrimaryButton
              text={"Read the Migration Guide"}
              styled={primaryButtonStyle}
              bgVariant={primaryButtonVariant}
              onClick={() =>
                window.open(
                  "https://docs.grovs.io/s/docs/doc/firebase-dynamic-links-I14cQAKc9D",
                  "_blank"
                )
              }
            />

            <Link style={{ textDecoration: "none" }}>
              <OutlinedButton
                style={outlineButtonStyle}
                text={"Start Building with Grovs"}
                variant={outlineButtonVariant}
                onClick={() => {
                  window.open("https://app.grovs.io/register", "_blank");
                }}
              />
            </Link>
          </Line>
        </Content2>
      </Container>
    </FullPageContainer>
  );
};

export default FirebaseGetStarted;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  z-index: 2;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.engagementBg};
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 60px 80px;
  gap: 20px;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Content2 = styled.div`
  width: 100%;
  display: flex;
  justify-content: center; /* Add this */
  gap: 30px;
  align-items: center;
  z-index: 2;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  z-index: 2;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;
const Title = styled.h1`
  color: ${lightThemeColors.lightColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const DecorationWrapper = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  svg {
    height: 100%;
    width: 100%;
  }

  @media (max-width: 990px) {
    svg {
      height: 100%;
      width: unset;
    }
  }
`;
